import { usePublicTemplateProjects } from '@client/store/project';
import { orderBy } from 'lodash';
import React, { useMemo } from 'react';
import { Menu } from '@ui/menus/Menu';

import { useEditProjectDialogStore } from '../../EditProject/edit-project.store';
import { useOpenPaywallDialog } from '@features/projects/Paywall/paywall.hook';

export const PublicTemplatesMenu: React.FC = () => {
  const { set } = useEditProjectDialogStore();
  const { isBehindPaywall: shouldOpenPaywallDialog, openPaywallDialog } =
    useOpenPaywallDialog();

  const projects = usePublicTemplateProjects();

  const menuItems = useMemo(() => {
    return orderBy(projects, 'name').map((project) => ({
      id: project.id,
      label: project.name,
      onClick: () => {
        if (shouldOpenPaywallDialog('create-project')) {
          openPaywallDialog('create-project');
          return;
        }
        set({ type: 'project', mode: 'create', id: Number(project.id) });
      },
    }));
  }, [projects, set, shouldOpenPaywallDialog, openPaywallDialog]);

  return (
    <Menu.Submenu label="Public templates" disabled={projects.length === 0}>
      {menuItems.map((item) => (
        <Menu.Item key={item.id} onClick={item.onClick}>
          {item.label}
        </Menu.Item>
      ))}
    </Menu.Submenu>
  );
};

export default PublicTemplatesMenu;
